import { FETCH_PAGINATED_PRODUCTS, RESET_PRODUCTS, FETCH_ALL_PRODUCTS, FETCH_ALL_PRODUCTS_BASIC, FETCH_ALL_PRODUCT_TRANSACTIONS, FETCH_ALL_PRODUCT_TRANSACTIONSV2, FETCH_PRODUCT_TRANSACTIONSV2, ADD_PRODUCT_PRICE, UPDATE_PRODUCT_PRICE, REMOVE_PRODUCT_PRICE, FETCH_PRODUCT_PRICES, PRODUCT_QUERY, SET_PRODUCT_GROUPING } from './../../mutation-types';

export default {
  [FETCH_PAGINATED_PRODUCTS](state, { products, pagination }) {
    state.items = products;
    state.pagination = pagination;
  },

  [RESET_PRODUCTS](state) {
    state.items = [];
    state.all = [];
    state.basic = [];
    state.pagination = {};
  },

  [FETCH_ALL_PRODUCTS](state, products) {
    state.all = products;
  },

  [FETCH_ALL_PRODUCTS_BASIC](state, products) {
    state.basic = products;
  },

  [FETCH_ALL_PRODUCT_TRANSACTIONS](state, transactions) {
    state.transactions = transactions;
  },

  [FETCH_ALL_PRODUCT_TRANSACTIONSV2](state, transactionsV2) {
    state.transactionsV2 = transactionsV2;
  },

  [FETCH_PRODUCT_TRANSACTIONSV2](state, { transactionsV2, pagination }) {
    state.paginateTransactionsV2.items = transactionsV2;
    state.paginateTransactionsV2.pagination = pagination;
  },

  [ADD_PRODUCT_PRICE](state, productPrice) {
    state.productPrices.push(productPrice);
  },

  [UPDATE_PRODUCT_PRICE](state, { index, productPrice }) {
    state.productPrices[index] = productPrice;
  },

  [REMOVE_PRODUCT_PRICE](state, index) {
    state.productPrices.splice(index, 1);
  },
  [FETCH_PRODUCT_PRICES](state, productPrices) {
    state.productPrices = productPrices;
  },
  [PRODUCT_QUERY](state, { page, limit, search, grouping }) {
    state.query.page = page;
    state.query.limit = limit;
    state.query.search = search;
    state.query.grouping = grouping;
    state.query.isSet = true;
  },
  [SET_PRODUCT_GROUPING](state, grouping) {
    state.query.grouping = grouping;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/product/mutations.js